/* this might be a server component but is used by the component recognizer which has to be able to register server components */
'use client';

import { cn } from '@packages/shared/src/utils/cn/cn';
import { rewriteCmsImageUrls } from '@packages/shared/src/utils/rewriteCmsImageUrls/rewriteCmsImageUrls';
import { CmsTable } from '../CmsTable/CmsTable.client';
import { type HtmlTableEditorType } from '../CmsTable/CmsTable.types';
import { type HtmlEditorType } from './CmsHtml.types';
import { useProcessHtmlLinks } from './hooks/useProcessHtmlLinks';
import { getFinalDangerouslyHTML } from './utils/getFinalDangerouslyHTML';

/**
 * Component that renders an HTML paragraph and styles its containing tags
 */
export const CmsHtml = ({
  data,
  className,
}: {
  data: HtmlEditorType | HtmlTableEditorType;
  className?: string;
}) => {
  const {
    field_distance: distanceType,
    field_margin: margin,
    field_padding: padding,
    field_background_color: background = 'transparent',
    field_active_border: activeBorder = false,
    field_html_editor: htmlContent,
    field_text_align: textAlign = 'left',
    id,
  } = data;

  const getHtmlContent = rewriteCmsImageUrls(getFinalDangerouslyHTML(htmlContent) ?? '');
  const processHtmlLinks = useProcessHtmlLinks();
  const tmpHTML = processHtmlLinks(getHtmlContent);
  const finalHTML = tmpHTML.replaceAll('{--}', '&shy;');

  // delegate to cmsTable if table_json exists
  if ('table_json' in data) {
    return <CmsTable data={data} />;
  }
  return (
    <div
      key={id}
      className={cn(
        '_c_cms_html',
        activeBorder && 'border-color-info border-2',
        distanceType === 'variation-1' && 'px-3 lg:px-0',
        className,
      )}
      style={{
        ...(margin && { margin }),
        ...(distanceType !== 'variation-1' &&
          padding && {
            padding,
          }),
        textAlign,
        ...(background && { background }),
      }}
      dangerouslySetInnerHTML={{ __html: finalHTML }}
    />
  );
};
